import { __decorate } from "tslib";
import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
let ConsultStore = class ConsultStore extends VuexModule {
    advancedSearchData = null;
    setAdvancedSearch(data) {
        this.advancedSearchData = data;
    }
};
__decorate([
    Mutation
], ConsultStore.prototype, "setAdvancedSearch", null);
ConsultStore = __decorate([
    Module({
        namespaced: true,
    })
], ConsultStore);
export default ConsultStore;
